import { render, staticRenderFns } from "./HeaderDialog.vue?vue&type=template&id=60570b4c&scoped=true&"
import script from "./HeaderDialog.vue?vue&type=script&lang=js&"
export * from "./HeaderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60570b4c",
  null
  
)

export default component.exports